(() => {
  if (customElements.get('slib-localization-form')) return;

  class SlibLocalizationForm extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
      this.button = this.querySelector('button');
      this.panel = this.querySelector('[data-localization-panel]');

      if (!this.input || !this.button || !this.panel) return;

      this.onButtonClick = this.onButtonClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);

      this.button.addEventListener('click', this.onButtonClick);
      this.button.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('keyup', this.onKeyUp);
      this.querySelectorAll('a[data-value]').forEach((item) => {
        item.addEventListener('click', (event) => this.onItemClick(event));
      });
    }

    disconnectedCallback() {
      if (!this.button) return;
      this.button.removeEventListener('click', this.onButtonClick);
      this.button.removeEventListener('focusout', this.onFocusOut);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    hidePanel() {
      this.button.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
    }

    onButtonClick() {
      this.panel.hidden = !this.panel.hidden;
      this.button.setAttribute('aria-expanded', String(!this.panel.hidden));
    }

    onFocusOut(event) {
      if (!event.relatedTarget || !this.contains(event.relatedTarget)) {
        this.hidePanel();
      }
    }

    onKeyUp(event) {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') {
        this.hidePanel();
        this.button.focus();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }

  customElements.define('slib-localization-form', SlibLocalizationForm);
})();
